export { default as RichText } from './RichText'
